import styled from 'styled-components';
import { COLORS } from './Color';

interface UnitSwitchProps {
  unit: string;
  setUnit: (unit: string) => void;
}

const UnitSwitch = ({ unit, setUnit }: UnitSwitchProps) => {
  return (
    <UnitSwitchBtn
      onClick={() => {
        unit === '평' ? setUnit('㎡') : setUnit('평');
      }}
    >
      <img src="/assets/images/icon/rotation.svg" alt="" />
      {unit === '평' ? '㎡' : '평'}
    </UnitSwitchBtn>
  );
};

export default UnitSwitch;

const UnitSwitchBtn = styled.div`
  height: 24px;
  padding: 0 6px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid ${COLORS.lineNormal};
  font-family: 'Pretendard-Medium';
  font-size: 14px;
  color: ${COLORS.labelNormal};
  cursor: pointer;
`;
